import "core-js/modules/es.array.push.js";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { ElMessageBox } from "element-plus";
import { useToast } from "vue-toastification";
import { cancelClassEvent, cancelEvent, cancelLegacyEventSignManager, changeLegacyEventOrganiser, getClassActivitySignResult, getClassActivityMembers, getClassActivityEvaluations, getClassActivityJoinMaterialInfo, getClassActivityMidwayRecords, getClassActivityMidwayStatus, getClassActivityNewsList, getClassActivityVotePlayers, getClassCanSignActivityList, getClassCollectedActivityList, getClassActivityDetail, getClassActivityList, getClassManagedActivityList, getClassMyActivityList, getLegacyEventMembers, isClassSession, joinClassEvent, joinEvent, newEventList, queryActivityDetailById, setLegacyEventSignManager, addClassActivityNews, signClassActivityMidway, signInClassActivityUserQr, signInClassActivityGps, signOutClassActivityUserQr, signOutClassActivityGps, submitClassActivityEvaluation, voteClassActivityPlayer } from "@/utils/api";
import { formatTime } from "@/utils/utils";
import { safeList } from "@/utils/http";
const readUserData = () => {
  try {
    return JSON.parse(localStorage.getItem("userData") || "null");
  } catch (error) {
    console.error(error);
    return null;
  }
};
const displayValue = value => value === undefined || value === null || value === "" ? "—" : value;
const successMessage = (payload, fallback) => payload?.msg || payload?.message || fallback;
const firstValue = (...values) => values.find(value => value !== undefined && value !== null && value !== "");
const getActivityId = (info = {}) => {
  const raw = info.raw || {};
  return firstValue(info.id, info.activityId, info.actiId, raw.id, raw.activityId, raw.actiId);
};
const isSuccessResponse = payload => payload?.code === 0 || String(payload?.code) === "0" || payload?.status === 1 || payload?.success === true || payload?.message === "success" || payload?.msg === "成功";
const readableFlag = value => {
  if (value === true) return "是";
  if (value === false) return "否";
  if (String(value) === "0") return "否";
  if (String(value) === "1") return "是";
  return displayValue(value);
};
const formatSignResult = payload => {
  const data = payload?.data || payload?.content;
  if (!data || typeof data !== "object") return successMessage(payload, "");
  const rows = [["签到", firstValue(data.signInStatus, data.signIn, data.isSignIn, data.sign_in_status)], ["签退", firstValue(data.signOutStatus, data.signOut, data.isSignOut, data.sign_out_status)], ["签到人数", firstValue(data.signInNum, data.sign_in_num, data.signInCount)], ["签退人数", firstValue(data.signOutNum, data.sign_out_num, data.signOutCount)]].filter(([, value]) => value !== undefined && value !== null && value !== "");
  if (!rows.length) return successMessage(payload, "");
  return rows.map(([label, value]) => `${label}：${readableFlag(value)}`).join("；");
};
const describeGeoError = error => {
  if (error?.code === 1) return "定位权限被拒绝，请手动填写签到地点。";
  if (error?.code === 2) return "无法获取当前位置，请手动填写签到地点。";
  if (error?.code === 3) return "定位超时，请重试或手动填写签到地点。";
  return "获取当前位置失败，请手动填写签到地点。";
};
const formatExtraTime = value => {
  if (!value) return "";
  const text = String(value);
  if (/^\d+$/.test(text)) {
    const number = Number(text);
    return formatTime(number > 100000000000 ? Math.floor(number / 1000) : number);
  }
  const parsed = Date.parse(text.replace(/-/g, "/"));
  return Number.isNaN(parsed) ? text : formatTime(Math.floor(parsed / 1000));
};
export default {
  setup() {
    const events = ref([]);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalItems = ref(0);
    const searchQuery = ref("");
    const toast = useToast();
    const loading = ref(false);
    const actionLoading = ref(false);
    const detailDialogVisible = ref(false);
    const detailInfo = ref(null);
    const signAddress = ref("");
    const signLoading = ref(false);
    const locating = ref(false);
    const signAction = ref("");
    const signResultText = ref("");
    const lastActionMessage = ref("");
    const managerTargetUid = ref("");
    const managerLoading = ref(false);
    const managerAction = ref("");
    const memberKeyword = ref("");
    const memberListLoading = ref(false);
    const managerMembers = ref([]);
    const memberPage = ref(1);
    const memberPageSize = ref(10);
    const memberPageInfo = ref(null);
    const activityExtraLoading = ref(false);
    const activityExtraMessage = ref("");
    const activityNews = ref([]);
    const activityEvaluations = ref([]);
    const activityVotePlayers = ref([]);
    const activityJoinMaterial = ref(null);
    const activityMidwayStatus = ref(null);
    const activityMidwayRecords = ref([]);
    const activityWriteLoading = ref(false);
    const activityWriteAction = ref("");
    const announceTitle = ref("");
    const evaluationStar = ref(5);
    const evaluationPics = ref("");
    const votePlayerId = ref("");
    const hasNextPage = computed(() => {
      if (totalItems.value) return currentPage.value * pageSize.value < totalItems.value;
      return events.value.length >= pageSize.value;
    });
    const canRegister = (start, end) => {
      const now = Math.floor(Date.now() / 1000);
      const startInt = Number.parseInt(start, 10);
      const endInt = Number.parseInt(end, 10);
      if (!startInt || !endInt) return false;
      return now >= startInt && now <= endInt;
    };
    const registerableCount = computed(() => events.value.filter(event => canRegister(event.startline, event.deadline)).length);
    const currentDetailId = computed(() => getActivityId(detailInfo.value));
    const activityIdOf = event => getActivityId(event);
    const canUseLocalSign = computed(() => {
      const userData = readUserData();
      return localStorage.getItem("loggedIn") === "true" && isClassSession(userData);
    });
    const isGpsSignActivity = computed(() => String(detailInfo.value?.signType) === "2" || String(detailInfo.value?.is_gps_sign) === "1");
    const canSubmitGpsSign = computed(() => canUseLocalSign.value && isGpsSignActivity.value);
    const canUseLegacyEventAdmin = computed(() => {
      const userData = readUserData();
      return localStorage.getItem("loggedIn") === "true" && !isClassSession(userData) && Boolean(userData?.oauth_token && userData?.oauth_token_secret);
    });
    const canViewEventMembers = computed(() => canUseLocalSign.value || canUseLegacyEventAdmin.value);
    const memberHasPrev = computed(() => memberPage.value > 1);
    const memberHasNext = computed(() => {
      const total = Number(memberPageInfo.value?.count || 0);
      if (total) return memberPage.value * memberPageSize.value < total;
      return managerMembers.value.length >= memberPageSize.value;
    });
    const memberTotalText = computed(() => {
      const total = memberPageInfo.value?.count;
      if (!total && !managerMembers.value.length) return "";
      return `成员：${total || managerMembers.value.length} 人`;
    });
    const signMethodText = computed(() => detailInfo.value?.signTypeName || (isGpsSignActivity.value ? "GPS 定位" : "扫码 / 普通签到"));
    const joinStatusText = computed(() => {
      const status = detailInfo.value?.joinStatus || {};
      if (status.name) return status.name;
      if (String(status.joinStatus) === "1") return "已报名";
      if (String(detailInfo.value?.userStatus?.hasJoin) === "1") return "已报名";
      return "未报名";
    });
    const userSignStatusText = computed(() => {
      const status = detailInfo.value?.userStatus || {};
      const parts = [];
      if (String(status.hasSignIn) === "1") parts.push("已签到");
      if (String(status.hasSignOut) === "1") parts.push("已签退");
      if (String(status.hasMidSign) === "1") parts.push("已中途签到");
      return parts.length ? parts.join(" / ") : "未签到";
    });
    const activityMidwayStatusText = computed(() => {
      const data = activityMidwayStatus.value?.data || activityMidwayStatus.value?.content || activityMidwayStatus.value;
      if (!data) return "未加载";
      if (typeof data === "string") return data;
      const status = firstValue(data.status, data.signStatus, data.hasSign, data.open);
      if (status !== undefined) return readableFlag(status);
      return successMessage(activityMidwayStatus.value, "已加载");
    });
    const goLogin = () => {
      window.location.hash = "#/login";
    };
    const ensureLoggedIn = () => {
      const loggedIn = localStorage.getItem("loggedIn");
      const userData = readUserData();
      const valid = loggedIn === "true" && userData && (isClassSession(userData) || userData.oauth_token && userData.oauth_token_secret);
      if (!valid) {
        toast.error("未登录或 token 失效，请重新登录", {
          position: "top-center"
        });
        goLogin();
        return null;
      }
      return userData;
    };
    const resetActivityExtras = () => {
      activityExtraMessage.value = "";
      activityNews.value = [];
      activityEvaluations.value = [];
      activityVotePlayers.value = [];
      activityJoinMaterial.value = null;
      activityMidwayStatus.value = null;
      activityMidwayRecords.value = [];
      activityWriteAction.value = "";
      announceTitle.value = "";
      evaluationStar.value = 5;
      evaluationPics.value = "";
      votePlayerId.value = "";
    };
    const resetSignPanel = (info = {}) => {
      signAddress.value = firstValue(info.location, info.address) || "";
      signResultText.value = "";
      signAction.value = "";
      lastActionMessage.value = "";
      managerTargetUid.value = "";
      managerAction.value = "";
      memberKeyword.value = "";
      managerMembers.value = [];
      memberPage.value = 1;
      memberPageInfo.value = null;
      resetActivityExtras();
    };
    const loadSignResult = async actiId => {
      const userData = readUserData();
      if (!actiId || !userData || !isClassSession(userData)) return;
      try {
        const response = await getClassActivitySignResult(userData, actiId);
        const text = formatSignResult(response);
        if (text) signResultText.value = text;
      } catch (error) {
        console.warn("sign result fetch failed", error);
      }
    };
    const loadActivityExtras = async (actiId = currentDetailId.value) => {
      const userData = readUserData();
      if (!actiId || !userData || !isClassSession(userData)) return;
      activityExtraLoading.value = true;
      activityExtraMessage.value = "";
      try {
        const [news, evaluations, votePlayers, material, midwayStatus, midwayRecords] = await Promise.allSettled([getClassActivityNewsList(userData, actiId, 1, 5), getClassActivityEvaluations(userData, actiId, 1, 5), getClassActivityVotePlayers(userData, actiId, 1, 5), getClassActivityJoinMaterialInfo(userData, actiId), getClassActivityMidwayStatus(userData, actiId), getClassActivityMidwayRecords(userData, actiId, 1, 5)]);
        const usable = result => result.status === "fulfilled" && (result.value?.code === undefined || isSuccessResponse(result.value));
        const failedCount = [news, evaluations, votePlayers, material, midwayStatus, midwayRecords].filter(result => !usable(result)).length;
        activityNews.value = usable(news) ? safeList(news.value) : [];
        activityEvaluations.value = usable(evaluations) ? safeList(evaluations.value) : [];
        activityVotePlayers.value = usable(votePlayers) ? safeList(votePlayers.value) : [];
        activityJoinMaterial.value = usable(material) ? material.value?.content || null : null;
        activityMidwayStatus.value = usable(midwayStatus) ? midwayStatus.value : null;
        activityMidwayRecords.value = usable(midwayRecords) ? safeList(midwayRecords.value) : [];
        activityExtraMessage.value = failedCount ? `${failedCount} 个补充接口当前不可用或无权限，已显示可读取的数据。` : "补充信息已刷新。";
      } catch (error) {
        activityExtraMessage.value = error?.message || "补充信息读取失败。";
        console.error(error);
      } finally {
        activityExtraLoading.value = false;
      }
    };
    const submitActivityWriteAction = async action => {
      const userData = ensureLoggedIn();
      if (!userData) return;
      if (!isClassSession(userData)) {
        toast.error("活动写入接口需要新版 Class 登录。", {
          position: "top-center"
        });
        return;
      }
      const actiId = currentDetailId.value;
      if (!actiId) {
        toast.error("活动 ID 缺失，无法提交。", {
          position: "top-center"
        });
        return;
      }
      const labels = {
        news: "发布公告",
        evaluate: "提交评价",
        vote: "投票",
        midway: "中途签到"
      };
      const label = labels[action] || "提交操作";
      const checks = {
        news: () => announceTitle.value.trim(),
        evaluate: () => evaluationStar.value,
        vote: () => votePlayerId.value.trim(),
        midway: () => true
      };
      if (!checks[action]?.()) {
        toast.error(`${label}参数不完整。`, {
          position: "top-center"
        });
        return;
      }
      try {
        await ElMessageBox.confirm(`确认对活动 ${actiId} 执行「${label}」？这是服务端真实写入操作。`, "写入确认", {
          type: "warning",
          center: true,
          customClass: "action-confirm-box",
          confirmButtonText: "确认提交",
          cancelButtonText: "取消",
          autofocus: false
        });
      } catch (error) {
        return;
      }
      activityWriteLoading.value = true;
      activityWriteAction.value = action;
      try {
        let response;
        if (action === "news") {
          response = await addClassActivityNews(userData, actiId, announceTitle.value);
        } else if (action === "evaluate") {
          response = await submitClassActivityEvaluation(userData, actiId, evaluationStar.value, evaluationPics.value.trim());
        } else if (action === "vote") {
          response = await voteClassActivityPlayer(userData, actiId, votePlayerId.value.trim());
        } else {
          response = await signClassActivityMidway(userData, actiId);
        }
        const message = successMessage(response, isSuccessResponse(response) ? `${label}成功` : `${label}失败`);
        lastActionMessage.value = message;
        if (isSuccessResponse(response)) {
          toast.success(message, {
            position: "top-center"
          });
          await loadActivityExtras(actiId);
          await refreshDetail(actiId);
        } else {
          toast.error(message, {
            position: "top-center"
          });
        }
      } catch (error) {
        lastActionMessage.value = error?.message || `${label}失败，请确认权限或活动状态。`;
        toast.error(lastActionMessage.value, {
          position: "top-center"
        });
        console.error(error);
      } finally {
        activityWriteLoading.value = false;
        activityWriteAction.value = "";
      }
    };
    const fetchData = async () => {
      const userData = ensureLoggedIn();
      if (!userData) return;
      loading.value = true;
      try {
        if (isClassSession(userData)) {
          const response = await getClassActivityList(userData, currentPage.value, searchQuery.value, pageSize.value);
          const list = safeList(response);
          events.value = list;
          totalItems.value = response?.total_count || list.length;
          return;
        }
        const response = await newEventList(userData.sid, searchQuery.value, "", currentPage.value, userData.oauth_token, userData.oauth_token_secret);
        const list = safeList(response);
        events.value = list;
        totalItems.value = response?.total_count || response?.content?.total_count || list.length;
      } catch (error) {
        if (error?.data?.message === "授权失败" || error?.response?.data?.message === "授权失败") {
          toast.error("未登录或 token 失效，请重新登录", {
            position: "top-center"
          });
          goLogin();
        } else {
          toast.error("获取活动信息失败，请检查网络连接。", {
            position: "top-center"
          });
          console.error(error);
        }
      } finally {
        loading.value = false;
      }
    };
    const fetchCanSignEvents = async () => {
      const userData = ensureLoggedIn();
      if (!userData) return;
      if (!isClassSession(userData)) {
        toast.error("可签到活动列表需要新版 Class 登录。", {
          position: "top-center"
        });
        return;
      }
      loading.value = true;
      try {
        const response = await getClassCanSignActivityList(userData);
        const list = safeList(response);
        events.value = list;
        currentPage.value = 1;
        totalItems.value = list.length;
        searchQuery.value = "";
        toast.success(list.length ? "已加载可签到活动" : "当前暂无可签到活动", {
          position: "top-center"
        });
      } catch (error) {
        toast.error("获取可签到活动失败，请检查网络连接。", {
          position: "top-center"
        });
        console.error(error);
      } finally {
        loading.value = false;
      }
    };
    const fetchClassEventSource = async (loader, label, {
      clearSearch = true
    } = {}) => {
      const userData = ensureLoggedIn();
      if (!userData) return;
      if (!isClassSession(userData)) {
        toast.error(`${label}需要新版 Class 登录。`, {
          position: "top-center"
        });
        return;
      }
      loading.value = true;
      try {
        const response = await loader(userData);
        const list = safeList(response);
        events.value = list;
        currentPage.value = 1;
        totalItems.value = response?.total_count || list.length;
        if (clearSearch) searchQuery.value = "";
        toast.success(list.length ? `已加载${label}` : `${label}暂无数据`, {
          position: "top-center"
        });
      } catch (error) {
        toast.error(`获取${label}失败，请检查权限或网络。`, {
          position: "top-center"
        });
        console.error(error);
      } finally {
        loading.value = false;
      }
    };
    const fetchMyClassEvents = () => fetchClassEventSource(userData => getClassMyActivityList(userData, 1, pageSize.value, 1), "我的活动");
    const fetchManagedClassEvents = () => fetchClassEventSource(userData => getClassManagedActivityList(userData, 1, searchQuery.value.trim(), pageSize.value, 0), "我管理的活动", {
      clearSearch: false
    });
    const fetchCollectedClassEvents = () => fetchClassEventSource(userData => getClassCollectedActivityList(userData, 1, pageSize.value), "收藏活动");
    const ensureLegacyEventAdminSession = () => {
      const userData = ensureLoggedIn();
      if (!userData) return null;
      if (isClassSession(userData) || !userData.oauth_token || !userData.oauth_token_secret) {
        toast.error("该管理接口需要旧版 Web 登录；请在设置中切换 Web 通道后重新登录。", {
          position: "top-center"
        });
        return null;
      }
      return userData;
    };
    const loadEventMembers = async (page = 1) => {
      const userData = ensureLoggedIn();
      if (!userData) return;
      const actiId = currentDetailId.value;
      if (!actiId) {
        toast.error("活动 ID 缺失，无法查询成员。", {
          position: "top-center"
        });
        return;
      }
      if (!isClassSession(userData) && !canUseLegacyEventAdmin.value) {
        toast.error("请使用 Class 或旧版 Web 登录后查看成员列表。", {
          position: "top-center"
        });
        return;
      }
      memberListLoading.value = true;
      try {
        const response = isClassSession(userData) ? await getClassActivityMembers(userData, actiId, page, memberPageSize.value) : await getLegacyEventMembers(userData.oauth_token, userData.oauth_token_secret, actiId, {
          page,
          status: 1,
          realname: memberKeyword.value.trim()
        });
        const list = safeList(response);
        managerMembers.value = list;
        memberPage.value = page;
        memberPageInfo.value = response?.pageInfo || response?.data?.pageInfo || response?.content?.pageInfo || null;
        toast.success(list.length ? "已加载成员列表" : "没有匹配成员", {
          position: "top-center"
        });
      } catch (error) {
        toast.error(error?.message || "查询成员失败，请确认当前账号有查看权限。", {
          position: "top-center"
        });
        console.error(error);
      } finally {
        memberListLoading.value = false;
      }
    };
    const submitLegacyManagerAction = async action => {
      const userData = ensureLegacyEventAdminSession();
      if (!userData) return;
      const actiId = currentDetailId.value;
      const uid = managerTargetUid.value.trim();
      if (!actiId) {
        toast.error("活动 ID 缺失，无法提交管理操作。", {
          position: "top-center"
        });
        return;
      }
      if (!uid) {
        toast.error("请先填写成员 UID。", {
          position: "top-center"
        });
        return;
      }
      const labels = {
        "set-sign": "设为签到员",
        "cancel-sign": "取消签到员",
        "set-organiser": "设为工作人员",
        "cancel-organiser": "取消工作人员"
      };
      const label = labels[action] || "提交管理操作";
      try {
        await ElMessageBox.confirm(`确认将成员 UID ${uid} ${label}？该操作仅活动管理员/组织者有权限。`, "活动管理确认", {
          type: "warning",
          center: true,
          customClass: "action-confirm-box",
          confirmButtonText: "确认提交",
          cancelButtonText: "取消",
          autofocus: false
        });
      } catch (error) {
        return;
      }
      managerLoading.value = true;
      managerAction.value = action;
      try {
        let response;
        if (action === "set-sign") {
          response = await setLegacyEventSignManager(userData.oauth_token, userData.oauth_token_secret, uid, actiId);
        } else if (action === "cancel-sign") {
          response = await cancelLegacyEventSignManager(userData.oauth_token, userData.oauth_token_secret, uid, actiId);
        } else {
          response = await changeLegacyEventOrganiser(userData.oauth_token, userData.oauth_token_secret, uid, actiId, action === "set-organiser");
        }
        const message = successMessage(response, isSuccessResponse(response) ? `${label}成功` : `${label}失败`);
        lastActionMessage.value = message;
        if (isSuccessResponse(response)) {
          toast.success(message, {
            position: "top-center"
          });
          await loadEventMembers(memberPage.value);
        } else {
          toast.error(message, {
            position: "top-center"
          });
        }
      } catch (error) {
        lastActionMessage.value = error?.message || `${label}失败，请确认当前账号有活动管理权限。`;
        toast.error(lastActionMessage.value, {
          position: "top-center"
        });
        console.error(error);
      } finally {
        managerLoading.value = false;
        managerAction.value = "";
      }
    };
    const handleRowClick = async row => {
      const userData = ensureLoggedIn();
      if (!userData) return;
      try {
        const actiId = getActivityId(row);
        if (!actiId) throw new Error("活动 ID 缺失");
        if (isClassSession(userData)) {
          const response = await getClassActivityDetail(userData, actiId);
          detailInfo.value = response.content;
          resetSignPanel(response.content);
          detailDialogVisible.value = true;
          await loadSignResult(actiId);
          await loadActivityExtras(actiId);
          return;
        }
        const response = await queryActivityDetailById(actiId, userData.oauth_token, userData.oauth_token_secret);
        detailInfo.value = response.content;
        resetSignPanel(response.content);
        detailDialogVisible.value = true;
      } catch (error) {
        toast.error("获取详细信息失败，请检查网络连接。", {
          position: "top-center"
        });
        console.error(error);
      }
    };
    const searchEvents = () => {
      currentPage.value = 1;
      fetchData();
    };
    const refreshDetail = async actiId => {
      const userData = readUserData();
      if (!userData || !actiId) return;
      try {
        if (isClassSession(userData)) {
          const response = await getClassActivityDetail(userData, actiId);
          detailInfo.value = response.content;
          if (!signAddress.value) signAddress.value = firstValue(response.content?.location, response.content?.address) || "";
          await loadSignResult(actiId);
          await loadActivityExtras(actiId);
        } else {
          const response = await queryActivityDetailById(actiId, userData.oauth_token, userData.oauth_token_secret);
          detailInfo.value = response.content;
          if (!signAddress.value) signAddress.value = firstValue(response.content?.location, response.content?.address) || "";
        }
      } catch (error) {
        console.error(error);
      }
    };
    const joinCurrentEvent = async actiId => {
      const userData = ensureLoggedIn();
      if (!userData) return;
      if (!actiId) {
        toast.error("活动 ID 缺失，无法报名。", {
          position: "top-center"
        });
        return;
      }
      try {
        await ElMessageBox.confirm("确认报名该活动？", "报名确认", {
          type: "warning",
          center: true,
          customClass: "action-confirm-box",
          confirmButtonText: "确认报名",
          cancelButtonText: "取消",
          autofocus: false
        });
      } catch (error) {
        return;
      }
      actionLoading.value = true;
      try {
        if (isClassSession(userData)) {
          const response = await joinClassEvent(userData, actiId);
          if (isSuccessResponse(response)) {
            const message = successMessage(response, "报名成功，记得准时签到哦~");
            lastActionMessage.value = message;
            toast.success(message, {
              position: "top-center"
            });
            await refreshDetail(actiId);
            await fetchData();
          } else {
            const message = successMessage(response, "报名失败");
            lastActionMessage.value = message;
            toast.error(message, {
              position: "top-center"
            });
          }
          return;
        }
        const uid = firstValue(userData.user_info?.uid, userData.uid, userData.mid);
        if (!uid) {
          toast.error("用户 ID 缺失，无法生成报名签名。", {
            position: "top-center"
          });
          return;
        }
        const response = await joinEvent(uid, actiId, userData.oauth_token, userData.oauth_token_secret);
        if (isSuccessResponse(response)) {
          const message = successMessage(response, "报名成功，记得准时签到哦~");
          lastActionMessage.value = message;
          toast.success(message, {
            position: "top-center"
          });
          await refreshDetail(actiId);
          await fetchData();
        } else {
          const message = successMessage(response, "报名失败");
          lastActionMessage.value = message;
          toast.error(message, {
            position: "top-center"
          });
        }
      } catch (error) {
        lastActionMessage.value = error?.message || "报名活动失败，请检查网络连接。";
        toast.error(lastActionMessage.value, {
          position: "top-center"
        });
        console.error(error);
      } finally {
        actionLoading.value = false;
      }
    };
    const cancelCurrentEvent = async actiId => {
      const userData = ensureLoggedIn();
      if (!userData) return;
      if (!actiId) {
        toast.error("活动 ID 缺失，无法取消报名。", {
          position: "top-center"
        });
        return;
      }
      try {
        await ElMessageBox.confirm("确认取消报名该活动？", "取消确认", {
          type: "warning",
          center: true,
          customClass: "action-confirm-box",
          confirmButtonText: "确认取消",
          cancelButtonText: "返回",
          autofocus: false
        });
      } catch (error) {
        return;
      }
      actionLoading.value = true;
      try {
        if (isClassSession(userData)) {
          const response = await cancelClassEvent(userData, actiId);
          if (isSuccessResponse(response)) {
            const message = successMessage(response, "取消成功");
            lastActionMessage.value = message;
            toast.success(message, {
              position: "top-center"
            });
            await refreshDetail(actiId);
            await fetchData();
          } else {
            const message = successMessage(response, "取消失败");
            lastActionMessage.value = message;
            toast.error(message, {
              position: "top-center"
            });
          }
          return;
        }
        const response = await cancelEvent(actiId, userData.oauth_token, userData.oauth_token_secret);
        if (isSuccessResponse(response)) {
          const message = successMessage(response, "取消成功");
          lastActionMessage.value = message;
          toast.success(message, {
            position: "top-center"
          });
          await refreshDetail(actiId);
          await fetchData();
        } else {
          const message = successMessage(response, "取消失败");
          lastActionMessage.value = message;
          toast.error(message, {
            position: "top-center"
          });
        }
      } catch (error) {
        lastActionMessage.value = error?.message || "取消报名失败，请检查网络连接。";
        toast.error(lastActionMessage.value, {
          position: "top-center"
        });
        console.error(error);
      } finally {
        actionLoading.value = false;
      }
    };
    const fillCurrentLocation = async () => {
      if (!navigator.geolocation) {
        toast.error("当前环境不支持定位，请手动填写签到地点。", {
          position: "top-center"
        });
        return;
      }
      locating.value = true;
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 30000
          });
        });
        const latitude = Number(position.coords.latitude).toFixed(6);
        const longitude = Number(position.coords.longitude).toFixed(6);
        const accuracy = Number.isFinite(position.coords.accuracy) ? Math.round(position.coords.accuracy) : 0;
        const baseAddress = firstValue(detailInfo.value?.location, detailInfo.value?.address, "当前位置");
        signAddress.value = `${baseAddress}（经度 ${longitude}，纬度 ${latitude}${accuracy ? `，精度约 ${accuracy}m` : ""}）`;
        toast.success("已填入当前位置", {
          position: "top-center"
        });
      } catch (error) {
        toast.error(describeGeoError(error), {
          position: "top-center"
        });
        console.error(error);
      } finally {
        locating.value = false;
      }
    };
    const submitLocalSign = async mode => {
      const userData = ensureLoggedIn();
      if (!userData) return;
      if (!isClassSession(userData)) {
        toast.error("本地签到需要新版 Class 登录，请在设置中切换通道后重新登录。", {
          position: "top-center"
        });
        return;
      }
      const actiId = getActivityId(detailInfo.value);
      const address = signAddress.value.trim();
      const isGpsMode = mode.startsWith("gps-");
      const isOut = mode.endsWith("-out");
      const actionLabel = `${isGpsMode ? "GPS 定位" : "扫码/普通"}${isOut ? "签退" : "签到"}`;
      if (!actiId) {
        toast.error("活动 ID 缺失，无法提交签到。", {
          position: "top-center"
        });
        return;
      }
      if (isGpsMode && !canSubmitGpsSign.value) {
        toast.error("当前活动不是 GPS 定位签到，不能调用定位签到接口。", {
          position: "top-center"
        });
        return;
      }
      if (isGpsMode && !address) {
        toast.error("请先填写签到地点或获取当前位置。", {
          position: "top-center"
        });
        return;
      }
      try {
        await ElMessageBox.confirm(`确认以当前账号提交${actionLabel}？`, "签到确认", {
          type: "warning",
          center: true,
          customClass: "action-confirm-box",
          confirmButtonText: `确认${isOut ? "签退" : "签到"}`,
          cancelButtonText: "取消",
          autofocus: false
        });
      } catch (error) {
        return;
      }
      signLoading.value = true;
      signAction.value = mode;
      try {
        let response;
        if (isGpsMode) {
          response = isOut ? await signOutClassActivityGps(userData, actiId, address) : await signInClassActivityGps(userData, actiId, address);
        } else {
          response = isOut ? await signOutClassActivityUserQr(userData, actiId) : await signInClassActivityUserQr(userData, actiId);
        }
        if (isSuccessResponse(response)) {
          const message = successMessage(response, `${actionLabel}提交成功`);
          signResultText.value = message;
          lastActionMessage.value = message;
          toast.success(message, {
            position: "top-center"
          });
          await refreshDetail(actiId);
          await fetchData();
        } else {
          const message = successMessage(response, `${actionLabel}失败`);
          signResultText.value = message;
          lastActionMessage.value = message;
          toast.error(message, {
            position: "top-center"
          });
        }
      } catch (error) {
        lastActionMessage.value = error?.message || `${actionLabel}失败，请检查网络连接。`;
        toast.error(lastActionMessage.value, {
          position: "top-center"
        });
        console.error(error);
      } finally {
        signLoading.value = false;
        signAction.value = "";
      }
    };
    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value -= 1;
        fetchData();
      }
    };
    const nextPage = () => {
      if (!hasNextPage.value) return;
      currentPage.value += 1;
      fetchData();
    };
    const convert = inputValue => {
      if (String(inputValue) === "0") return "否";
      if (String(inputValue) === "1") return "是";
      return "—";
    };
    const copySignInfo = async info => {
      const text = [`活动ID：${info?.actiId || info?.id || "—"}`, `活动名称：${info?.name || "—"}`, `签到方式：${info?.signTypeName || (String(info?.is_gps_sign) === "1" ? "GPS 定位" : "扫码 / 普通签到")}`, `需要签退：${convert(info?.is_need_sign_out)}`].join("\n");
      try {
        await navigator.clipboard.writeText(text);
        toast.success("已复制活动签到信息", {
          position: "top-center"
        });
      } catch (error) {
        console.error(error);
        toast.info(text, {
          position: "top-center",
          timeout: 6000
        });
      }
    };
    onMounted(() => {
      fetchData();
    });
    onBeforeUnmount(() => {
      detailDialogVisible.value = false;
      detailInfo.value = null;
    });
    return {
      events,
      currentPage,
      searchQuery,
      searchEvents,
      fetchCanSignEvents,
      fetchMyClassEvents,
      fetchManagedClassEvents,
      fetchCollectedClassEvents,
      prevPage,
      nextPage,
      hasNextPage,
      formatTime,
      handleRowClick,
      detailDialogVisible,
      detailInfo,
      convert,
      joinCurrentEvent,
      cancelCurrentEvent,
      canRegister,
      registerableCount,
      currentDetailId,
      activityIdOf,
      loading,
      actionLoading,
      canUseLocalSign,
      canSubmitGpsSign,
      canUseLegacyEventAdmin,
      canViewEventMembers,
      signMethodText,
      joinStatusText,
      userSignStatusText,
      signAddress,
      signLoading,
      locating,
      signAction,
      signResultText,
      lastActionMessage,
      managerTargetUid,
      managerLoading,
      managerAction,
      memberKeyword,
      memberListLoading,
      managerMembers,
      memberPage,
      memberHasPrev,
      memberHasNext,
      memberTotalText,
      activityExtraLoading,
      activityExtraMessage,
      activityNews,
      activityEvaluations,
      activityVotePlayers,
      activityJoinMaterial,
      activityMidwayStatusText,
      activityMidwayRecords,
      activityWriteLoading,
      activityWriteAction,
      announceTitle,
      evaluationStar,
      evaluationPics,
      votePlayerId,
      loadActivityExtras,
      submitActivityWriteAction,
      loadEventMembers,
      submitLegacyManagerAction,
      fillCurrentLocation,
      submitLocalSign,
      displayValue,
      readableFlag,
      formatExtraTime,
      copySignInfo
    };
  }
};